export const REPORT_SECTIONS = [
  { key: 'deviationReport', label: 'Deviation Report' },
  { key: 'projectInfo', label: 'Project Info' },
  { key: 'summaryText', label: 'Executive Summary' },
  { key: 'revisionHistory', label: 'Revision History' },
  { key: 'projectContacts', label: 'Project Contacts' },
  { key: 'tableOfContents', label: 'Table of Contents' },
  { key: 'generalInformation', label: 'General Information' },
  { key: 'referenceImage', label: 'Reference Image' },
  { key: 'repairAssessment', label: 'Component Overview' },
  { key: 'findingsRAT', label: 'Findings (RAT)' },
  {
    key: 'factFindingField',
    label: 'Work performed for Fact Finding Inspection',
  },
  { key: 'workPerformedRepairField', label: 'Work performed for Repair' },
  {
    key: 'repairsRecommendationsUpgradesField',
    label: 'Repairs Not Completed, Recommendations & Upgrades',
  },
  { key: 'recommendedWorkRepair', label: 'Recommended Work for Repair' },
  { key: 'newParts', label: 'New Parts' },
  // Tasks inside the selected phase
  { key: 'inspectionTasks', label: 'Phase Tasks' },
  // Tasks outside the selected phase
  { key: 'additionalTasks', label: 'Additional Project Phase Tasks' },
  { key: 'appendix', label: 'Appendix' },
];

export default REPORT_SECTIONS;
